<template>
  <v-btn
    :outline="outline !== undefined ? outline : flat"
    :flat="flat"
    :color="color"
    :class="[size, { 'white--text': !flat }, { 'v-btn--flat': true }, 'cz-button']"
    :loading="load"
    :disabled="disabled || ignoreDisabled"
    @click="clicked"
  >
    <slot name="body">
      <v-icon
        v-if="icon"
        :color="colorIcon"
      >
        {{ icon }}
      </v-icon>
      {{ text }}
    </slot>
  </v-btn>
</template>
<script>
import CommonMixin from '@/mixins/common'
import { mapGetters } from 'vuex'
export default {
  mixins: [CommonMixin],
  props: {
    icon: {
      type: String,
      default: ''
    },
    colorIcon: {
      type: String,
      default: '#007AFF'
    },
    text: {
      type: String,
      default: 'SALVAR'
    },
    flat: {
      type: Boolean,
      default: true
    },
    outline: {
      type: Boolean,
      default: undefined
    },
    ignore: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    load: {
      type: Boolean,
      default: false
    },
    style: {
      type: Object,
      default: () => {}
    },
    color: {
      type: String,
      default: '#26A7DD'
    },
    size: {
      type: String,
      default: 'large'
    }
  },
  computed: {
    ...mapGetters(['loggedUserExpirated', 'loggedUserInactive']),
    ignoreDisabled() {
      return (
        !this.ignore && (this.loggedUserExpirated || this.loggedUserInactive)
      )
    }
  },
  methods: {
    clicked() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.cz-button {
  border-radius: 0;
  margin: 0;
}
</style>
